import styled from '@emotion/styled'
import { Button } from 'antd'
import React, { useEffect, useState } from 'react'
import { Show } from '../../../components/common/Show'
import { ConsultarStore } from './ConsultarStore'
import { Alunos } from './alunos/ListaAlunos'
import { Turmas } from './turmas/ListaTurmas'

export const ConsultarContainer = () => {
  const { Layout } = ConsultarContainer
  const dispatch = ConsultarStore.useDispatch()

  useEffect(() => {
    dispatch(ConsultarStore.thunks.getTurmas())
    dispatch(ConsultarStore.thunks.getAgendamentos())
  }, [])

  return (
    <Layout>
      <Header />
      <Content />
    </Layout>
  )
}
ConsultarContainer.Layout = styled.div`
  padding: 10px 50px;
  display: grid;
  row-gap: 10px;
`

const Header = () => {
  const { Layout } = Header

  const dispatch = ConsultarStore.useDispatch()
  const { cfcOrigem } = ConsultarStore.useState()

  const handleClick = () => {
    dispatch(ConsultarStore.actions.logout())
  }

  return (
    <Layout>
      <h2 className="cfc-name">{cfcOrigem?.fantasia}</h2>
      <div>
        {' '}
        CNPJ: <strong>{cfcOrigem?.cnpj}</strong>
      </div>
      <div>
        {' '}
        Município:{' '}
        <strong>
          <em>{cfcOrigem?.municipio}</em>
        </strong>
      </div>
      <Button onClick={handleClick}>Alterar</Button>
    </Layout>
  )
}
Header.Layout = styled.div`
  margin-top: 10px;
  padding: 10px;
  display: flex;
  column-gap: 30px;
  grid-template-columns: 300px 100px 1fr;
  align-items: center;
  background: white;
  border-radius: 4px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);

  .cfc-name {
    color: #524b4b;
    margin-top: 4px;
  }
`

const Content = () => {
  const { Layout, TabHeader, TabBtn, TabContent } = Content

  const [tab, setTab] = useState('TURMAS')

  const handleClick = (e: any) => {
    setTab(e.target.value)
  }

  return (
    <Layout>
      <TabHeader>
        <TabBtn value="TURMAS" tab={tab} onClick={handleClick}>
          Turmas
        </TabBtn>
        <TabBtn value="AGENDAMENTOS" tab={tab} onClick={handleClick}>
          Alunos
        </TabBtn>
      </TabHeader>

      <TabContent>
        <Show condition={tab === 'TURMAS'}>
          <Turmas />
        </Show>

        <Show condition={tab === 'AGENDAMENTOS'}>
          <Alunos />
        </Show>
      </TabContent>
    </Layout>
  )
}
Content.Layout = styled.div`
  padding: 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
`
Content.TabHeader = styled.div`
  overflow: hidden;
  display: flex;
  column-gap: 20px;
`
Content.TabBtn = ({ value, tab, ...props }: any) => {
  const { Btn } = Content

  return (
    <Btn style={value === tab ? { borderColor: '#555657' } : {}} {...{ value, ...props }}></Btn>
  )
}
Content.Btn = styled.button`
  background-color: inherit;
  float: left;
  border: none;
  border-bottom: 1px solid #ccc;
  width: 150px;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
`
Content.TabContent = styled.div`
  padding: 6px 12px;
  border-top: none;
`
